import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component RecurringCheckmarkSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <RecurringCheckmarkSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <RecurringCheckmarkSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RecurringCheckmarkSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="RecurringCheckmarkSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M1 5.874a5.002 5.002 0 008.743 3.442l-.78-.45 2.3-.982.3 2.482-.939-.542A6.002 6.002 0 01.001 6.141l1-.267zm6.93-1.177a.5.5 0 010 .707L5.975 7.39a.5.5 0 01-.707 0l-.971-.975a.5.5 0 01.707-.708l.617.622 1.602-1.63a.5.5 0 01.707 0zM9 .804a5.996 5.996 0 013 5.052l-1.001.268.001-.043a5.002 5.002 0 00-8.743-3.398l.779.451-2.3.982-.298-2.482.938.54A6.002 6.002 0 019 .805z"
        fillRule="evenodd"
      />
    </svg>
  )
);
RecurringCheckmarkSmallIcon.displayName = "RecurringCheckmarkSmallIcon";
export default RecurringCheckmarkSmallIcon;
